import { getBlob } from "../Services/ApiBase";
import { API_ENDPOINTS } from "../Services/ApiEndPoints";
import { getApiErrorMessage } from "./apiErrorMessage";
import { blobToErrorMessage, parseFilenameFromContentDisposition } from "./downloadClientsExport";

/**
 * GET /projects/export?format=csv|xlsx and save the file — exports the projects matching
 * `filters` (same `clientName` / `projectName` / `status` query params as GET /projects).
 *
 * @param {{ clientName?: string, projectName?: string, status?: string }} [filters]
 * @param {"csv"|"xlsx"} [format]
 */
export async function downloadProjectsExport(filters = {}, format = "csv") {
  const fmt = format === "xlsx" ? "xlsx" : "csv";
  const params = { format: fmt };
  for (const key of ["clientName", "projectName", "status"]) {
    if (filters[key]) params[key] = filters[key];
  }

  try {
    const response = await getBlob(API_ENDPOINTS.PROJECTS.EXPORT, params);

    const blob = response.data;
    const contentType = String(
      response.headers?.["content-type"] || response.headers?.["Content-Type"] || ""
    );

    if (contentType.includes("application/json")) {
      throw new Error(await blobToErrorMessage(blob));
    }

    const fallback = `projects-export.${fmt}`;
    const cd =
      response.headers?.["content-disposition"] || response.headers?.["Content-Disposition"];
    const filename = parseFilenameFromContentDisposition(cd) || fallback;

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    if (err === "Request canceled") throw err;
    const data = err?.response?.data;
    if (data instanceof Blob) {
      const msg = await blobToErrorMessage(data);
      throw new Error(msg, { cause: err });
    }
    throw new Error(getApiErrorMessage(err, "Export failed"), { cause: err });
  }
}
